'use strict';

// Cookie durations
const COOKIE_DURATION_ONE_YEAR = 31536000000; //  ms = 31536000 seconds = 365 days = 1 year

// Cookie names
const COOKIE_NAME_FOR_PREFERRED_LOCALE = 'HW_preferred_locale';
const COOKIE_NAME_FOR_GTM_CUSTOM_SESSION_ID = 'custom_session_id';
const COOKIE_NAME_FOR_SALESFORCE_UNAUTHENTICATED_SESSION_ID = 'dwsid';

// Functions
const setCookie = (name, value, duration = COOKIE_DURATION_ONE_YEAR) => {
  const date = new Date();
  date.setTime(date.getTime() + duration);
  document.cookie =
    name + '=' + value + '; expires=' + date.toGMTString() + '; path=/';
};

const getCookie = (name) => {
  const cookies = document.cookie.split(';');
  const cookie = cookies.find((cookie) => cookie.includes(name));
  return cookie ? cookie.split('=')[1] : null;
};

const deleteCookie = (name) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

// Export
export {
  COOKIE_DURATION_ONE_YEAR,
  COOKIE_NAME_FOR_PREFERRED_LOCALE,
  COOKIE_NAME_FOR_GTM_CUSTOM_SESSION_ID,
  COOKIE_NAME_FOR_SALESFORCE_UNAUTHENTICATED_SESSION_ID,
  setCookie,
  getCookie,
  deleteCookie
};
